<template>
	<div>
		<div class="position-relative">

            <!-- shape Hero -->
            <section class="section-shaped my-0">
                <div class="shape shape-style-1 shape-default shape-skew">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div class="container shape-container d-flex">
                    <div class="col px-0">
                        <div class="row">
                            <div class="col-lg-6">
                                <h1 class="display-3  text-white">Zero Inside
                                    <span>Perusahaan Jasa Software dan Website </span>
                                </h1>
                                <p class="lead  text-white"> Sebuah startup di bidang jasa pembuatan website, aplikasi, desain, IT solution, install ulang laptop, pembuatan video aerial maupun video profile. Kami siap membantu kebutuhan Anda. Kontak kami! </p>
                                <div class="btn-wrapper">
                                    <base-button tag="a"
                                                 href="/contact"
                                                 class="mb-3 mb-sm-0"
                                                 type="info"
                                                 icon="fa fa-code">
                                        Contact Us
                                    </base-button>
                                </div>
                            </div>
                            <div class="col-lg-6"> 
                                <img src="img/brand/zeroinside.png" class="img-fluid floating">
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- 1st Hero Variation -->
            <services></services>
            <recent-works></recent-works>
            <testimonials></testimonials>
		</div>
		
	</div>
</template>
<script>

    import Services from "./components/Services";
    import RecentWorks from "./components/RecentWorks"; 
    import Testimonials from "./components/Testimonials";
    export default  {
        name : 'components',
        components : {
            Services,
            RecentWorks,
            Testimonials
        }        
    };
</script>
